import { render, staticRenderFns } from "./table-filters.vue?vue&type=template&id=373393fb&scoped=true"
import script from "./table-filters.vue?vue&type=script&lang=ts"
export * from "./table-filters.vue?vue&type=script&lang=ts"
import style0 from "./table-filters.vue?vue&type=style&index=0&id=373393fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373393fb",
  null
  
)

export default component.exports